<template>
  <div class="panel-container">
    <div class="panel-item-container" v-for="item in data" :key="item.id">
      <div class="panel-item">
        <div class="panel-item-inner">
          <span class="iconfont" :class="item.icon"></span>
          <span>{{ item.number }}</span>
        </div>
      </div>
      <div class="title">
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [
        { id: 0, icon: "icon-wuliuquanqiuwuliu", number: "120", text: this.$t('track.trackPancel.text01') },
        { id: 2, icon: "icon-logisticsFlowChart", number: "100", text: this.$t('track.trackPancel.text02') },
        { id: 3, icon: "icon-yunshuzhongwuliu-xianxing", number: "1450", text: this.$t('track.trackPancel.text03') },
        { id: 4, icon: "icon-wuliupeisong-13", number: "805", text: this.$t('track.trackPancel.text04') },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@import url("../../../assets/iconfont/iconfont.css");
.panel-container {
  box-sizing: border-box;
  height: 560px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: url("../../../assets/images/track/map_bg.png") no-repeat;
  background-size: 50% 100%;
  background-position: center;

  .panel-item-container {
    .panel-item {
      box-sizing: border-box;
      width: 240px;
      height: 240px;
      overflow: hidden;
      border-radius: 50%;
      background-color: #ff5d1b;

      .panel-item-inner {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 8px solid #333342;
        border-radius: 50%;
        background-color: #40404a;
        transition-property: background-color;
        transition-duration: 0.3s;
        color: #fff;

        span {
          font-size: 48px;
          font-weight: bold;
        }
      }

      &:hover {
        border: 1px solid #ff5d1b;
        .panel-item-inner {
          border: 8px solid #fff;
          background-color: #ff5d1b;
        }
      }
    }

    .title{
      margin-top: 24px;
      text-align: center;
      font-size: 24px;
    }
  }
}
</style>